import "./Startbtn.css";
import React from "react";
import { Link } from "react-router-dom";

function Startbtn({ title }) {
  const Startpage = [{ name: "profile", path: "/Profile" }];

  return (
    <div classNme="start">
      {Startpage.map((profile, index) => {
        return (
          <Link to={profile.path} key={index}>
            <button className="startbtn">{title}</button>
          </Link>
        );
      })}
    </div>
  );
}

export default Startbtn;
